<template>
  <footer class="footer">
    <div class="container inner">
      <div class="col">
        <div class="name">{{ company.nameKo }} <span class="en">{{ company.nameEn }}</span></div>
        <div class="meta">대표 {{ company.ceo }} · {{ company.address }}</div>
        <div class="meta"><a :href="company.phoneLink">{{ company.phone }}</a> · <a :href="'mailto:' + company.email">{{ company.email }}</a></div>
      </div>
      <nav class="links" aria-label="푸터 메뉴">
        <a href="#about" @click.prevent="go('about')">회사소개</a>
        <a href="#business" @click.prevent="go('business')">사업분야</a>
        <a href="#partners" @click.prevent="go('partners')">파트너·연혁</a>
        <a href="#contact" @click.prevent="go('contact')">오시는 길</a>
        <a :href="company.brochure" download>회사소개서</a>
      </nav>
    </div>
    <div class="container copy">© {{ year }} NK System. All rights reserved. <span class="ai-note">일부 이미지는 AI로 생성되었습니다.</span></div>
  </footer>
</template>

<script>
import { company } from '@/data/company';
import { scrollToSection } from '@/scroll';

export default {
  name: 'SiteFooter',
  data() {
    return { company, year: new Date().getFullYear() };
  },
  methods: {
    go(id) {
      if (this.$route.path !== '/') { this.$router.push({ path: '/', hash: '#' + id }); return; }
      scrollToSection(id);
    },
  },
};
</script>

<style scoped>
.footer { background: var(--navy-2); color: var(--on-dark); font-size: 13px; }
.inner { padding: 40px 0 24px 0; display: flex; justify-content: space-between; gap: 32px; }
.col { display: flex; flex-direction: column; gap: 6px; }
.name { color: #ffffff; font-weight: 700; font-size: 15px; }
.en { color: var(--on-dark); font-weight: 500; margin-left: 6px; }
.meta a { color: var(--on-dark); }
.meta a:hover { color: #ffffff; }
.links { display: flex; gap: 20px; align-items: flex-start; flex-wrap: wrap; }
.links a { color: var(--on-dark-strong); font-weight: 500; }
.links a:hover { color: var(--orange); }
.copy { padding: 0 0 28px 0; color: #64748b; }
.ai-note { margin-left: 8px; }
@media (max-width: 900px) {
  .inner { flex-direction: column; gap: 20px; }
}
</style>
